export default __webpack_public_path__ + "static/media/miguel-lopes-32.4f18713e.jpg";